import { inject, Injectable, DOCUMENT } from '@angular/core';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ResetVersionProvider {
  private readonly document = inject(DOCUMENT);

  get localStorage() {
    return this.document.defaultView.localStorage;
  }

  async validateVersion() {
    const localVersion = this.localStorage.getItem('LOCAL_VERSION');
    const version = environment.version;

    if (localVersion !== version) {
      this.localStorage.clear();
      this.localStorage.setItem('LOCAL_VERSION', version);
      this.document.defaultView.location.reload();
    }
  }
}
